import { render, staticRenderFns } from "./AbbreviatedFilingContent.vue?vue&type=template&id=35d05292&"
import script from "./AbbreviatedFilingContent.vue?vue&type=script&lang=js&"
export * from "./AbbreviatedFilingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
